export default function initVideo(video) {
  const videoContainer = video.closest('.video-container');
  const videoWrapper = video.parentNode;
  const playButton = videoContainer?.querySelector('[data-video-play]');
  const posterElem = videoContainer?.querySelector('.video-poster');

  if (!playButton || !posterElem) return;

  playButton.addEventListener('click', () => {
    posterElem.classList.add('hidden');
    videoWrapper.classList.remove('hidden');
    video.play();
  });
}
